export default __webpack_public_path__ + "static/media/barley.bc6c1980.png";